//WMS - 仓库管理api
import {ServerDistApi} from '@/group-cloud/network/ServerBizApi';
import {ServerProdApidl} from '@/group-cloud/network/ServerBizApi';

export class WmsStockApi {

    constructor() {
    }
    protected static groupUrl = '/stock';

    //获取商品列表
    public static async query(data){
      let uri = this.groupUrl + '/query';
      return await ServerDistApi.send(uri, data);
    }
    //获取客户列表
    public static async queryCustomerList(data){
      // let uri ='/customer/man/client/suggest';
      let uri ='member/search/list';
      return await ServerProdApidl.send(uri, data);
    }
    //总部发货的时候获取商品信息
    public static async getSkuStocks(data){
      let uri = this.groupUrl + '/skuStocks';
      return await ServerDistApi.send(uri, data);
    }

    //获取订单类型
    public static async getOrderTypes(data){
        let uri ='/wms/skuChangeRecord/getOrderType';
        return await ServerDistApi.get(uri, data);
    }
    //获取单位选项
    public static async getUnitListOptions(data){
        let uri = this.groupUrl + '/selectBoxUnitList';
        return await ServerDistApi.get(uri, data);
    }

    //总仓库存查询订单占有明细
    public static async getOrderDetail(data){
        let uri ='/wms/skuChangeRecord/getOrderOccupyDetail';
        return await ServerDistApi.send(uri, data);
    }

    //客户库存查询订单占有明细
    public static async getOrderDetailK(data){
      let uri ='/wms/skuChangeRecord/getOrderOccupyDetailKehu';
      return await ServerDistApi.send(uri, data);
  }

    //查询仓库明细账
    public static async getStockDetail(data){
        let uri ='/wms/skuChangeRecord/getSkuChangeRecordList';
        return await ServerDistApi.send(uri, data);
    }

    //导出仓库明细账
    public static async export(data){
        let uri ='/wms/skuChangeRecord/exportStockDetail';
        return await ServerDistApi.send(uri, data);
    }


    //库存导出
    public static async allStockExport(data){
        let uri ='/stock/export';
        return await ServerDistApi.send(uri, data);
    }

    //导出库存明细账
    public static async stockDetailExport(data){
        let uri ='/stock/detail/export';
        return await ServerDistApi.send(uri, data);
    }

    //查询明细账总计
    public static async detailTotal(data){
      let uri ='/wms/skuChangeRecord/getSkuChangeCount';
      return await ServerDistApi.send(uri, data);
  }

}


